import React, { useState, useRef, Fragment } from "react";
import emailjs from "@emailjs/browser";
import Loading from "../Loading/Loading";
import { Rotate, Zoom } from "react-reveal";

const ContactUs = () => {
  const form = useRef();
  const [clientDetails, setClientDetails] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const onChange = (e) => {
    const { name, value } = e.target;

    setClientDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await emailjs
      .send(
        "service_9218tqv",
        "template_kfqt4gk",
        clientDetails,
        "wNhYj4CMJd7CF0d3k"
      )
      .then((res) => {
        console.log("Email Send Successfully");
        setClientDetails((prev) => ({
          ...prev,
          name: "",
          email: "",
          message: "",
          subject: "",
        }));
      })
      .catch((err) => {
        console.log("Comming in Else part");
      });
    setIsLoading(false);
    // service_8wzv3jf;
  };

  return (
    <Fragment>
      {isLoading && <Loading loader={true} />}
      <div id="Contact" className="container-xxl py-4">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">
              <Zoom left> Contact</Zoom>
            </h6>
            <Zoom right>
              <h1 className="mb-5 subtitle">Get In Touch With Us</h1>
            </Zoom>
          </div>

          <div className="row contact">
            <div className="col-lg-5 d-flex align-items-stretch">
              <div className="info">
                <div className="address">
                  <i className="bi bi-geo-alt"></i>
                  <Zoom>
                    <h4>Location</h4>
                  </Zoom>
                  <Zoom right>
                    <p className="text-justify">
                      101 , Action voice audio production Simran Plaza , corner
                      of 3rd & , Hasnabad Ln , Ram Krishna Nagar , Khar West ,
                      Mumbai , Maharashtra 400052
                    </p>
                  </Zoom>
                </div>

                <div className="email">
                  <i className="bi bi-envelope"></i>
                  <Zoom>
                    <h4>Email</h4>
                  </Zoom>
                  <Zoom right>
                    <p>contactactionvoice@gmail.com</p>
                  </Zoom>
                </div>

                <div className="phone">
                  <i className="bi bi-phone"></i>
                  <Zoom>
                    <h4>Call</h4>
                  </Zoom>
                  <Zoom right>
                    <p>+91 98197 78588</p>
                  </Zoom>
                </div>

                <Rotate right>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3770.819595250424!2d72.83710791485119!3d19.071667887090452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s101%20%2C%20Action%20voice%20audio%20production%20Simran%20Plaza%20%2C%20Mumbai%20%2C%20Maharashtra%20400052!5e0!3m2!1sen!2sin!4v1655921048624!5m2!1sen!2sin"
                    style={{
                      border: "0px",
                      width: "100%",
                      height: "290px",
                    }}
                    allowfullscreen
                    loading="lazy"
                    frameBorder="0"
                    referrerpolicy="no-referrer-when-downgrade"
                  />
                </Rotate>
              </div>
            </div>

            <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
              <form
                method="post"
                onSubmit={sendEmail}
                ref={form}
                className="php-email-form"
              >
                <div className="row">
                  <div className="form-group col-md-6">
                    <Zoom>
                      <label>Your Name</label>
                    </Zoom>
                    <Zoom left>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        value={clientDetails.name}
                        onChange={onChange}
                        required
                      />
                    </Zoom>
                  </div>
                  <div className="form-group col-md-6">
                    <Zoom>
                      <label>Your Email</label>
                    </Zoom>
                    <Zoom left>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={clientDetails.email}
                        onChange={onChange}
                        required
                      />
                    </Zoom>
                  </div>
                </div>
                <div className="form-group">
                  <Zoom>
                    <label>Subject</label>
                  </Zoom>
                  <Zoom left>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      id="subject"
                      value={clientDetails.subject}
                      onChange={onChange}
                      required
                    />
                  </Zoom>
                </div>
                <div className="form-group">
                  <Zoom>
                    <label>Message</label>
                  </Zoom>
                  <Zoom left>
                    <textarea
                      className="form-control"
                      name="message"
                      rows="10"
                      value={clientDetails.message}
                      onChange={onChange}
                      required
                    ></textarea>
                  </Zoom>
                </div>
                <div className="text-center">
                  <Zoom left>
                    <button type="submit">Send Message</button>
                  </Zoom>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ContactUs;
